<app-modal [open]="active" [name]="'opt-out'" (close)="closeDialog()">
  <div modal-header>Confirm SMS Opt-Out</div>
  <div modal-body>
    <p>
      You’re about to stop receiving SMS notifications for the phone
      number you previously opted in with:
      <b>{{ user.usePhoneForSms ? user.phone : user.phone2 }}</b
      >.
    </p>
    <p>Do you want to proceed?</p>
    <div class="opt-out-dialog__links">
      <a
        href="https://cretelligent.com/website-terms-of-use/"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="opt-out-terms-link"
        >Terms & Conditions</a
      >
      <a
        href="https://cretelligent.com/privacy-policy/"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="opt-out-privacy-link"
        >Privacy Policy</a
      >
    </div>
  </div>
  <button
    modal-footer
    type="button"
    class="btn btn--primary"
    data-testid="opt-out-confirm"
    (click)="submit()"
    [disabled]="isSubmitting"
  >
    Opt-Out
  </button>
  <button
    modal-footer
    type="button"
    class="btn btn--secondary"
    data-testid="opt-out-cancel"
    (click)="closeDialog()"
  >
    Cancel
  </button>
</app-modal>
